import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('files.routes.index'),
        name: i18n.t('files.routes.index'),
        component: () =>
            import(/* webpackChunkName: "files" */ '@/views/files/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('files.breadcrumbs.index'),
                    to: { name: i18n.t('files.routes.index') },
                    disable: true,
                },
            ],
        },
    },
]
